// Module
var code = "<div role=\"dialog\" aria-label=\"Select team\"> <item-searcher @select=\"select\" :filter=\"filter\" :loadData=\"loadData\" placeholder=\"Search Teams...\"> <div slot-scope=\"scope\"> {{ scope.item.Name }} </div> </item-searcher> </div> ";
// Exports
export default code;